import { CodeXml } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ProgrammingBrowserCodeIcon = createLucideIcon(CodeXml);
